function highlightNonMatch(text, searchTerm) {
  if (!text?.toLowerCase().startsWith(searchTerm?.toLowerCase())) {
    return text;
  }

  return (
    <>
      {text.slice(0, searchTerm.length)}
      <span className={'font-bold'}>{text.slice(searchTerm.length)}</span>
    </>
  );
}

export function QuickSearchSuggestionItem({
  searchTerm,
  suggestion,
  onClick
}: Readonly<{
  searchTerm: string;
  suggestion: string;
  onClick: (suggestion: string) => void;
}>) {
  return (
    <li className={'py-0.5'}>
      <button type="button"
        onClick={() => onClick(suggestion)}
        data-testid={`quicksearch-suggestion-${suggestion}`}
        className={'w-full text-left py-1.5 px-2 hover:text-primary hover:bg-primary-light rounded'}
      >
        {highlightNonMatch(suggestion, searchTerm)}
      </button>
    </li>
  );
}
